<template>
  <div class="mobile">
    <div class="mobileLogo">
      <img :src="obj?.mobile?.logo" alt="" class="mobileLogoImg" />
    </div>
    <img :src="obj?.mobile?.banner" alt="" class="mobileBanner" />
    <div class="mobileOverall">
      <img :src="obj?.mobile?.overview" alt="" class="mobileOverallImg" />
    </div>
    <img :src="obj?.mobile?.process" alt="" class="mobileProcess" />
    <div class="mobileLight">
      <img :src="obj?.mobile?.light" alt="" class="mobileLightImg" />
    </div>
    <div class="mobileSignup">
      <img :src="obj?.mobile?.signupTitle" alt="" class="mobileSignupTitle" />
    </div>
    <div class="mobileSwipe">
      <van-swipe class="mobileSwipeBox" :autoplay="3000" indicator-color="#3B985F">
        <van-swipe-item v-for="(item, index) in obj?.mobile?.children" :key="index">
          <img :src="item.icon" alt="" class="mobileSwipeBoxItem" />
          <img @click="handleClick(item.id)" :src="obj?.mobile?.btn" alt="" class="mobileBtn" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- <img :src="obj?.mobile?.btn" alt="" class="mobileBtn" /> -->
    <div class="mobileRule">
      <img :src="obj?.mobile?.rule" alt="" class="mobileRuleImg" />
    </div>
    <div class="mobileExpert">
      <img :src="obj?.mobile?.expert" alt="" class="mobileExpertImg" />
    </div>
    <div class="mobileOrg"><img :src="obj?.mobile?.org" alt="" class="mobileOrgImg" /></div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onUnmounted } from 'vue'
import { getRecruit } from '@/api/2024/index'
import { showConfirmDialog } from 'vant'

// let obj = ref({
//   logo: 'https://p5.ssl.qhimg.com/t11b673bcd6520b9656fdda65e7.png',
//   banner: 'https://p3.ssl.qhimg.com/t11b673bcd65934b000d4614aee.png',
//   overview: 'https://p4.ssl.qhimg.com/t11b673bcd693abaf56a1b11781.png',
//   process: 'https://p3.ssl.qhimg.com/t11b673bcd698fc35f7bb41e77e.png',
//   highlight: 'https://p3.ssl.qhimg.com/t11b673bcd6998c2952e54f7133.png',
//   signupTitle: 'https://p0.ssl.qhimg.com/t11b673bcd6a374a628bdca6aad.png',
//   track: [
//     {
//       photo: 'https://p5.ssl.qhimg.com/t11b673bcd6d42961cef3e33376.png',
//       id: 'safe'
//     },
//     {
//       photo: 'https://p5.ssl.qhimg.com/t11b673bcd68f22a238eebf788b.png',
//       id: 'ai'
//     },
//     {
//       photo: 'https://p0.ssl.qhimg.com/t11b673bcd60f03cdd26a52bc11.png',
//       id: 'isc'
//     }
//   ],
//   detail: 'https://p0.ssl.qhimg.com/t11b673bcd6da6e6f7b025b8291.png',
//   expertTitle: 'https://p5.ssl.qhimg.com/t11b673bcd60eb98b9945a6644a.png',
//   expertImg: 'https://p0.ssl.qhimg.com/t11b673bcd66ade60ff8c6b151b.png',
//   org: 'https://p5.ssl.qhimg.com/t11b673bcd64e5f7aff07ac6bd5.png',
//   mobile: {
//     logo: 'https://p5.ssl.qhimg.com/t11b673bcd64083a0c7c04e4ed7.png',
//     banner: 'https://p4.ssl.qhimg.com/t11b673bcd65be2a594cbbaa3ef.png',
//     overview: 'https://p3.ssl.qhimg.com/t11b673bcd63b4c299a1b5fecdf.png',
//     process: 'https://p4.ssl.qhimg.com/t11b673bcd6bae115bdc2ba327a.png',
//     light: 'https://p2.ssl.qhimg.com/t11b673bcd69c501f65b852796d.png',
//     signupTitle: 'https://p0.ssl.qhimg.com/t11b673bcd6bc7524957e5b49a3.png',
//     children: [
//       {
//         icon: 'https://p4.ssl.qhimg.com/t11b673bcd6489c83e7ada2a895.png',
//         id: 'safe'
//       },
//       {
//         icon: 'https://p5.ssl.qhimg.com/t11b673bcd6f6e7ea285e3dfb1e.png',
//         id: 'ai'
//       },
//       {
//         icon: 'https://p4.ssl.qhimg.com/t11b673bcd63bf75a02110a1e2e.png',
//         id: 'isc'
//       }
//     ],
//     btn: 'https://p5.ssl.qhimg.com/t11b673bcd6c068650deb881eb2.png',
//     rule: 'https://p2.ssl.qhimg.com/t11b673bcd60b1e52c7da4303d8.png',
//     expert: 'https://p5.ssl.qhimg.com/t11b673bcd6d166663ccef46943.png',
//     org: 'https://p5.ssl.qhimg.com/t11b673bcd692d4e5a2097175c3.png',
//     btnText: '请点击阅览《报名流程指导》，并按照步骤在PC端完成报名',
//     jumpLink: 'https://agent.360.cn/contest.html'
//   }
// })
let obj = ref({})
onBeforeMount(async () => {
  await fetch()
})

function fetch() {
  getRecruit('QnZtWWxnSnJjL0hkS2czamV3YkVFUT09Ojp1NhwBFqVZRMPIRLYcQ7H5')
    .then((res) => {
      let result = JSON.parse(res.data.data.data)
      // console.log(result.mobile)
      obj.value = result
    })
    .catch(() => {})
}

function handleClick(id) {
  if (id === 'isc') {
    const url = obj.value?.mobile?.jumpLink
    window.open(url, '_blank')
  } else {
    showConfirmDialog({
      message: obj.value?.mobile?.btnText
    })
      .then(() => {
        const url =
          'https://cdn.isc.360.com/isc-cxo/ISC.AI2024%E5%88%9B%E6%96%B0%E7%8B%AC%E8%A7%92%E5%85%BD%E6%B2%99%E7%9B%92%E5%A4%A7%E8%B5%9B-%E6%8A%A5%E5%90%8D%E6%B5%81%E7%A8%8B%E6%8C%87%E5%AF%BC.pdf'
        window.open(url, '_blank')
      })
      .catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.mobile {
  width: 100%;
  &Logo {
    height: 74px;
    padding: 20px 0 18px 24px;
    &Img {
      width: 129px;
    }
  }
  &Banner {
    width: 100%;
    display: block;
  }
  &Overall {
    padding: 55px 24px 47px;
    &Img {
      width: 100%;
    }
  }
  &Process {
    width: 100%;
    display: block;
  }
  &Light {
    padding: 63px 21px 110px 0;
    &Img {
      width: 100%;
    }
  }
  &Signup {
    padding: 0 24px 60px;
    &Title {
      width: 100%;
      display: block;
    }
  }
  &Swipe {
    padding: 0 24px;
    margin-bottom: 87px;
    position: relative;
    // background-color: pink;
    &Box {
      &Item {
        width: 100%;
        display: block;
      }
    }
  }
  &Btn {
    width: 150px;
    display: block;
    margin: 13px auto 0;
    // margin: 0 auto 87px;
  }
  &Rule {
    padding: 0 24px;
    &Img {
      width: 100%;
    }
  }
  &Expert {
    margin: 134px 0 112px;
    &Img {
      width: 100%;
    }
  }
  &Org {
    padding: 0 24px;
    margin-bottom: 128px;
    &Img {
      width: 100%;
    }
  }
}

:deep(.van-swipe__indicator) {
  width: 10px;
  height: 10px;
}

:deep(.van-swipe__indicators) {
  bottom: 87px;
}
</style>
